
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
// import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import * as moment from 'moment';
import { jsPDF } from 'jspdf';
import html2canvas from "html2canvas";
import logo from "assets/images/skglogo.jpg"
import * as service from '../../../services/service';

function PrintPurchaseOrder() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    // const [terms, setTerms] = useState('');
    const navigate = useNavigate();
    const params = useParams();

    const getDetailsById = () => {
        setLoading(true);
        if (params.id > 0) {
            fetch(
                service.GET_PURCHASE_ORDER_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        PurchaseOrderId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {                    
                    setData(result);

                    // const lines = result.termsConditions.split(/\n/);                    
                    // const withBreaks = lines.flatMap((line, index) =>
                    //     index > 0
                    //         ? [<br key={`br-${index}`} />, <Fragment key={index}>{line}</Fragment>]
                    //         : [line]
                    // );
                    // console.log(withBreaks);
                    // setTerms(withBreaks);
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        getDetailsById();
    }, []);

    const printDocument = () => {
        setTimeout(() => {
            setTimeout(() => {
                setLoading(true);
            }, 100);
            const divToPrint = document.querySelector('#divForm');
            html2canvas(divToPrint).then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const imgWidth = 190;
                const pageHeight = 290;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                let heightLeft = imgHeight;
                // eslint-disable-next-line new-cap
                const doc = new jsPDF('pt', 'mm');
                let position = 0;
                doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + 25);
                heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + 25);
                    heightLeft -= pageHeight;
                }
                doc.save('PurchaseOrder.pdf');
                setLoading(false);
            });
        }, 1000);
    }

    const backHandler = () => {
        navigate('/supplier/purchaseorder');
    }

    function replaceWithBr() {
        return data[0].termsConditions.replaceAll(";", "<br />")
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    {/* <Card style={{ alignItems: 'center' }}> */}
                    <div id="divForm" width="100%">
                        <Table width="100%" style={{ "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid', }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan="2" align="center">
                                        <Table>
                                            <TableRow>
                                                <TableCell width="20%" align="left">
                                                    <img src={logo} alt="logo" width="50%" height="50%" />
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                    SHEPL INDIA  PVT. LTD.
                                                    <br />
                                                    <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                                        S No.17/B,Plot No.5,Gala No.26, Pragati Industrial Complex,
                                                        <br />
                                                        Kothrud Industrial Estate, Pune-411038, India. Tel: +91-20- 25433054 • 25434328 •
                                                        <br />
                                                        Fax: +91-20-25469440,  Mobile : 9284964949, Email : vinayakduvedi@gmail.com / gm@shrikrishnagroup.co.in
                                                        <br />
                                                        Web :www.rocksplitter.in, GSTN: 27AAHCS5679M1ZH, CIN: U29219PN1998PTC013074
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan="2" align="center" style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }} />
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan="2" align="center" style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        PURCHASE ORDER
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell width="50%" style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        To,
                                        <br />
                                        {data[0] ? data[0].supplierName : ''}
                                        <br />
                                        {data[0] ? data[0].supplierAddress : ''}, {data[0] ? data[0].supplierDistrict : ''}, {data[0] ? data[0].supplierState : ''}
                                        <br />
                                        {data[0] ? data[0].supplierEmailId : ''}, {data[0] ? data[0].supplierContactNo : ''}, {data[0] ? data[0].supplierGSTNo : ''}
                                    </TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        <Table width="100%" style={{ "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid', }}>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    PO No :
                                                </TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    {data[0] ? data[0].purchaseOrderNo : ''}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    PO Date :
                                                </TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    {data[0] ? moment(data[0].purchaseOrderDate).format("DD/MM/YYYY") : ''}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    OUR REF :
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                                    VENDOR CODE :
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan="2" align="center" style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        Please supply the following material as per terms and conditions mentioned below
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan="2">
                                        <Table>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Sr.No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Material</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>HSN Code</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Unit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Rate</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>CGST ({data[0] ? data[0].cgstPercent : ''}%)</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>SGST ({data[0] ? data[0].sgstPercent : ''}%)</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>IGST ({data[0] ? data[0].igstPercent : ''}%)</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>Total</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.purchaseOrderId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{index + 1}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.material}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.hsnCode}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.quantity}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.unitOfMeasure}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.rate}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.amount}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.cgst}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.sgst}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.igst}</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>{row.totalAmount}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    {data[0] ?
                                        <TableCell style={{ whiteSpace: 'pre-line', fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                            Terms & Conditions
                                            <br />
                                            {data[0].termsConditions ?
                                                <p dangerouslySetInnerHTML={{ __html: replaceWithBr() }} />
                                                : null}
                                        </TableCell>
                                        : null}
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        Total (Rs) : {data[0] ? data[0].grandTotalAmount : ''}
                                        <br />
                                        Amount Rs. In Words:
                                        <br />
                                        {data[0] ? data[0].amountInWords : ''}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        Prepared By
                                        <br />
                                        {data[0] ? data[0].addedByName : ''}
                                        <br />
                                        {data[0] ? data[0].designation : ""}
                                    </TableCell>
                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                                        For SHEPL INDIA  PVT. LTD.
                                        <br />
                                        <br />
                                        <br />
                                        Authorized Signatory
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                    <MDBox mt={4} mb={1} textAlign="center">
                        {loading ? <Oval
                            heigth="20"
                            width="20"
                            color='grey'
                            ariaLabel='loading'
                        /> :
                            <div>
                                <MDButton color="info" onClick={() => printDocument()}>
                                    PRINT
                                </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                <MDButton color="info" onClick={backHandler}>
                                    BACK
                                </MDButton>
                            </div>
                        }
                        {/* {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null} */}
                    </MDBox>

                    {/* </Card> */}

                </Grid>
            </Grid>

            <Footer />
        </DashboardLayout>
    );
}

export default PrintPurchaseOrder;